import { combineReducers } from "redux";

import authReducer from "./auth";
import talentReducer from "./talents";
import eventReducer from "./events";
import shiftReducer from "./shifts";
import tierReducer from "./tiers";

const rootReducer = combineReducers({
  auth: authReducer,
  talent: talentReducer,
  events: eventReducer,
  shifts: shiftReducer,
  tiers: tierReducer
});

export default rootReducer;
